import React, { useState } from "react";
import {
  Box,
  Button,
  Popover,
  useMediaQuery,
  Drawer,
  Divider,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PropTypes from "prop-types";

const ReuseAction = ({ actions, mobileContent }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "reuse-popover" : null;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const handleClose = () => setAnchorEl(null);
  return (
    <Box>
      <Button
        aria-describedby={id}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        {matches ? <MoreHorizIcon /> : <MoreVertIcon />}
      </Button>
      {matches ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          onClick={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {actions}
        </Popover>
      ) : (
        <Drawer
          anchor="bottom"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
        >
          {mobileContent}
          <Divider />
          {actions}
        </Drawer>
      )}
    </Box>
  );
};

ReuseAction.propTypes = {
  actions: PropTypes.node.isRequired,
  mobileContent: PropTypes.node,
};

ReuseAction.defaultProps = {
  mobileContent: <div> </div>,
};

export default ReuseAction;
